import Icon from '../../../components/AppIcon';

export default function SystemHealth() {
  const healthMetrics = [
    { label: 'حالة الخادم', value: 'متصل', status: 'healthy', icon: 'Server' },
    { label: 'قاعدة البيانات', value: 'نشطة', status: 'healthy', icon: 'Database' },
    { label: 'وقت الاستجابة', value: '45ms', status: 'healthy', icon: 'Zap' },
    { label: 'استخدام الذاكرة', value: '62%', status: 'warning', icon: 'HardDrive' },
  ];

  const getStatusColor = (status) => {
    const statusMap = {
      healthy: { bg: 'bg-green-100', text: 'text-green-800', icon: '#10b981' },
      warning: { bg: 'bg-amber-100', text: 'text-amber-800', icon: '#f59e0b' },
      error: { bg: 'bg-red-100', text: 'text-red-800', icon: '#ef4444' },
    };
    return statusMap?.[status] || statusMap?.healthy;
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-slate-900" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
          مراقبة الأداء
        </h2>
        <div className="flex items-center gap-2 px-3 py-1 bg-green-100 text-green-800 rounded-full">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
          <span className="text-sm font-medium" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>صحي</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {healthMetrics?.map((metric, index) => {
          const colors = getStatusColor(metric?.status);
          return (
            <div key={index} className={`${colors?.bg} rounded-lg p-4`}>
              <div className="flex items-center gap-3 mb-2">
                <Icon name={metric?.icon} size={20} color={colors?.icon} />
                <span className={`text-sm font-medium ${colors?.text}`} style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
                  {metric?.label}
                </span>
              </div>
              <p className={`text-2xl font-bold ${colors?.text}`}>{metric?.value}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}